export const getNameOfUrlLocation = (pathname) => {
  const path = pathname.split('/');
  
  return path?.length === 5 ? "partner" : path[4];
};